import { useLocation } from 'react-router-dom';
import RouterPage from './routers/RouterPage';
import Global from './components/shared/global';
const _ = require('lodash');

function App() {
  return (
    <div className="body-content">
      <RouterPage />
      <Global />
    </div>
  );
}

export default App;